/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
	  };
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GQLDatagridSortModel = {
	field: string;
	segment?: string | null | undefined;
	sort: GQLSortDirection;
};

export type GQLFacetFilter = {
	facet?: string | null | undefined;
	value?: string | null | undefined;
};

export type GQLInteractionContactType =
	| "agent"
	| "appraiser"
	| "attorney"
	| "client"
	| "closingAttorney"
	| "counterpartyAgent"
	| "counterpartyAttorney"
	| "counterpartyClient"
	| "counterpartyTransactionCoordinator"
	| "escrowOfficer"
	| "homeWarranty"
	| "lender"
	| "other"
	| "propertyManagingAgent"
	| "titleOfficer"
	| "transactionCoordinator";

export type GQLInteractionQueryInput = {
	id: string | number;
	type: GQLInteractionType;
};

export type GQLInteractionStatus =
	| "acceptancePending"
	| "accepted"
	| "accepting"
	| "active"
	| "activeCont"
	| "backUp"
	| "buyerCountered"
	| "cancellationPending"
	| "cancelled"
	| "closed"
	| "comingSoon"
	| "counterOfferSent"
	| "countering"
	| "expired"
	| "handshake"
	| "lost"
	| "noStatus"
	| "offMarket"
	| "onMarket"
	| "pending"
	| "preListing"
	| "ratified"
	| "rejected"
	| "sellerCountered"
	| "underReview"
	| "withdrawn";

export type GQLInteractionType =
	| "clientGroup"
	| "lease"
	| "listing"
	| "offer"
	| "referral"
	| "userTemplate";

export type GQLInteractionsInput = {
	includeContacts?: boolean | null | undefined;
	isGlobal?: boolean | null | undefined;
	pagination?: GQLPaginationInput | null | undefined;
	type: GQLInteractionType;
};

export type GQLLeaseRepresentation = "dual" | "landlord" | "tenant";

export type GQLOfferExperience = "coversheet" | "featureFlag" | "lom";

export type GQLPaginationInput = {
	facets?: Array<string> | null | undefined;
	filters?: Array<GQLFacetFilter | null | undefined> | null | undefined;
	page: number;
	perPage: number;
	search?: string | null | undefined;
	sort?: Array<GQLDatagridSortModel | null | undefined> | null | undefined;
};

export type GQLSortDirection = "asc" | "desc";

export type GQLPageInfoFieldsFragment = {
	__typename: "PaginationPageInfo";
	totalPages: number;
	totalItems: number;
};

export type GQLInteractionContactFields_InteractionContactAgent_Fragment = {
	id: string | null;
	type: Types.GQLInteractionContactType;
	firstName: string | null;
	lastName: string | null;
	displayName: string;
	email: string | null;
	cellPhone: string | null;
	avatar: string | null;
	userId: string | null;
	order: number;
};

export type GQLInteractionContactFields_InteractionContactOther_Fragment = {
	id: string | null;
	type: Types.GQLInteractionContactType;
	firstName: string | null;
	lastName: string | null;
	displayName: string;
	email: string | null;
	cellPhone: string | null;
	avatar: string | null;
	userId: string | null;
	order: number;
};

export type GQLInteractionContactFieldsFragment =
	| GQLInteractionContactFields_InteractionContactAgent_Fragment
	| GQLInteractionContactFields_InteractionContactOther_Fragment;

export type GQLBasicInteractionContactFieldsFragment = {
	id: string;
	type: Types.GQLInteractionContactType;
	firstName: string | null;
	lastName: string | null;
	email: string | null;
	cellPhone: string | null;
	avatar: string | null;
	userId: string | null;
	teamId: string | null;
	order: number;
};

export type GQLInteractionFields_ClientGroup_Fragment = {
	__typename: "ClientGroup";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFields_Lease_Fragment = {
	__typename: "Lease";
	createdAt: string;
	representation: Types.GQLLeaseRepresentation | null;
	leaseStartDate: string | null;
	leaseEndDate: string | null;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFields_Listing_Fragment = {
	__typename: "Listing";
	createdAt: string;
	offerExperience: Types.GQLOfferExperience;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFields_Offer_Fragment = {
	__typename: "Offer";
	createdAt: string;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFields_Referral_Fragment = {
	__typename: "Referral";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFields_UserTemplate_Fragment = {
	__typename: "UserTemplate";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	contacts: Array<
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| {
				id: string | null;
				type: Types.GQLInteractionContactType;
				firstName: string | null;
				lastName: string | null;
				displayName: string;
				email: string | null;
				cellPhone: string | null;
				avatar: string | null;
				userId: string | null;
				order: number;
		  }
		| null
	> | null;
};

export type GQLInteractionFieldsFragment =
	| GQLInteractionFields_ClientGroup_Fragment
	| GQLInteractionFields_Lease_Fragment
	| GQLInteractionFields_Listing_Fragment
	| GQLInteractionFields_Offer_Fragment
	| GQLInteractionFields_Referral_Fragment
	| GQLInteractionFields_UserTemplate_Fragment;

export type GQLInteractionWithContactsFields_ClientGroup_Fragment = {
	__typename: "ClientGroup";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFields_Lease_Fragment = {
	__typename: "Lease";
	createdAt: string;
	representation: Types.GQLLeaseRepresentation | null;
	leaseStartDate: string | null;
	leaseEndDate: string | null;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFields_Listing_Fragment = {
	__typename: "Listing";
	createdAt: string;
	offerExperience: Types.GQLOfferExperience;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFields_Offer_Fragment = {
	__typename: "Offer";
	createdAt: string;
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFields_Referral_Fragment = {
	__typename: "Referral";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFields_UserTemplate_Fragment = {
	__typename: "UserTemplate";
	id: string;
	coverPhotoUrl: string | null;
	coverPhotoFileId: string | null;
	contractDate: string | null;
	listingStartDate: string | null;
	listingEndDate: string | null;
	onMarketDate: string | null;
	closingDate: string | null;
	displayPrice: number | null;
	displayStatus: Types.GQLInteractionStatus;
	isArchived: boolean;
	acceptedOfferId: string | null;
	property: {
		street1: string | null;
		street2: string | null;
		state: string | null;
		city: string | null;
		zip: string | null;
		county: string | null;
		mlsNumber: string | null;
	} | null;
	basicContacts: Array<{
		id: string;
		type: Types.GQLInteractionContactType;
		firstName: string | null;
		lastName: string | null;
		email: string | null;
		cellPhone: string | null;
		avatar: string | null;
		userId: string | null;
		teamId: string | null;
		order: number;
	}> | null;
};

export type GQLInteractionWithContactsFieldsFragment =
	| GQLInteractionWithContactsFields_ClientGroup_Fragment
	| GQLInteractionWithContactsFields_Lease_Fragment
	| GQLInteractionWithContactsFields_Listing_Fragment
	| GQLInteractionWithContactsFields_Offer_Fragment
	| GQLInteractionWithContactsFields_Referral_Fragment
	| GQLInteractionWithContactsFields_UserTemplate_Fragment;

export type GQLInteractionsWithContactsQueryVariables = Exact<{
	input: Types.GQLInteractionsInput;
}>;

export type GQLInteractionsWithContactsQuery = {
	interactions: {
		__typename: "InteractionsPaginationResult";
		pageInfo: {
			__typename: "PaginationPageInfo";
			totalPages: number;
			totalItems: number;
		};
		items: Array<
			| {
					__typename: "ClientGroup";
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
			| {
					__typename: "Lease";
					createdAt: string;
					representation: Types.GQLLeaseRepresentation | null;
					leaseStartDate: string | null;
					leaseEndDate: string | null;
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
			| {
					__typename: "Listing";
					createdAt: string;
					offerExperience: Types.GQLOfferExperience;
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
			| {
					__typename: "Offer";
					createdAt: string;
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
			| {
					__typename: "Referral";
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
			| {
					__typename: "UserTemplate";
					id: string;
					coverPhotoUrl: string | null;
					coverPhotoFileId: string | null;
					contractDate: string | null;
					listingStartDate: string | null;
					listingEndDate: string | null;
					onMarketDate: string | null;
					closingDate: string | null;
					displayPrice: number | null;
					displayStatus: Types.GQLInteractionStatus;
					isArchived: boolean;
					acceptedOfferId: string | null;
					property: {
						street1: string | null;
						street2: string | null;
						state: string | null;
						city: string | null;
						zip: string | null;
						county: string | null;
						mlsNumber: string | null;
					} | null;
					basicContacts: Array<{
						id: string;
						type: Types.GQLInteractionContactType;
						firstName: string | null;
						lastName: string | null;
						email: string | null;
						cellPhone: string | null;
						avatar: string | null;
						userId: string | null;
						teamId: string | null;
						order: number;
					}> | null;
			  }
		>;
	};
};

export type GQLInteractionQueryVariables = Exact<{
	input: Types.GQLInteractionQueryInput;
}>;

export type GQLInteractionQuery = {
	interaction:
		| {
				__typename: "ClientGroup";
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| {
				__typename: "Lease";
				createdAt: string;
				representation: Types.GQLLeaseRepresentation | null;
				leaseStartDate: string | null;
				leaseEndDate: string | null;
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| {
				__typename: "Listing";
				createdAt: string;
				offerExperience: Types.GQLOfferExperience;
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| {
				__typename: "Offer";
				createdAt: string;
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| {
				__typename: "Referral";
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| {
				__typename: "UserTemplate";
				id: string;
				coverPhotoUrl: string | null;
				coverPhotoFileId: string | null;
				contractDate: string | null;
				listingStartDate: string | null;
				listingEndDate: string | null;
				onMarketDate: string | null;
				closingDate: string | null;
				displayPrice: number | null;
				displayStatus: Types.GQLInteractionStatus;
				isArchived: boolean;
				acceptedOfferId: string | null;
				property: {
					street1: string | null;
					street2: string | null;
					state: string | null;
					city: string | null;
					zip: string | null;
					county: string | null;
					mlsNumber: string | null;
				} | null;
				contacts: Array<
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| {
							id: string | null;
							type: Types.GQLInteractionContactType;
							firstName: string | null;
							lastName: string | null;
							displayName: string;
							email: string | null;
							cellPhone: string | null;
							avatar: string | null;
							userId: string | null;
							order: number;
					  }
					| null
				> | null;
		  }
		| null;
};

export const PageInfoFieldsFragmentDoc = gql`
    fragment PageInfoFields on PaginationPageInfo {
  __typename
  totalPages
  totalItems
}
    `;
export const InteractionContactFieldsFragmentDoc = gql`
    fragment InteractionContactFields on InteractionContactBase {
  id
  type
  firstName
  lastName
  displayName
  email
  cellPhone
  avatar
  userId
  order
}
    `;
export const InteractionFieldsFragmentDoc = gql`
    fragment InteractionFields on Interaction {
  __typename
  id
  property {
    street1
    street2
    state
    city
    zip
    county
    mlsNumber
  }
  coverPhotoUrl
  coverPhotoFileId
  contractDate
  listingStartDate
  listingEndDate
  onMarketDate
  closingDate
  displayPrice
  displayStatus
  isArchived
  acceptedOfferId
  contacts(
    input: {filter: {types: [agent, counterpartyAgent, client, counterpartyClient]}}
  ) {
    ...InteractionContactFields
  }
  ... on Lease {
    createdAt
    representation
    leaseStartDate
    leaseEndDate
  }
  ... on Listing {
    createdAt
    offerExperience
  }
  ... on Offer {
    createdAt
  }
}
    ${InteractionContactFieldsFragmentDoc}`;
export const BasicInteractionContactFieldsFragmentDoc = gql`
    fragment BasicInteractionContactFields on BasicInteractionContactResponse {
  id
  type
  firstName
  lastName
  email
  cellPhone
  avatar
  userId
  teamId
  order
}
    `;
export const InteractionWithContactsFieldsFragmentDoc = gql`
    fragment InteractionWithContactsFields on Interaction {
  __typename
  id
  property {
    street1
    street2
    state
    city
    zip
    county
    mlsNumber
  }
  coverPhotoUrl
  coverPhotoFileId
  contractDate
  listingStartDate
  listingEndDate
  onMarketDate
  closingDate
  displayPrice
  displayStatus
  isArchived
  acceptedOfferId
  basicContacts {
    ...BasicInteractionContactFields
  }
  ... on Lease {
    createdAt
    representation
    leaseStartDate
    leaseEndDate
  }
  ... on Listing {
    createdAt
    offerExperience
  }
  ... on Offer {
    createdAt
  }
}
    ${BasicInteractionContactFieldsFragmentDoc}`;
export const InteractionsWithContactsDocument = gql`
    query InteractionsWithContacts($input: InteractionsInput!) {
  interactions(input: $input) {
    __typename
    pageInfo {
      ...PageInfoFields
    }
    items {
      ...InteractionWithContactsFields
    }
  }
}
    ${PageInfoFieldsFragmentDoc}
${InteractionWithContactsFieldsFragmentDoc}`;

/**
 * __useInteractionsWithContactsQuery__
 *
 * To run a query within a React component, call `useInteractionsWithContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionsWithContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionsWithContactsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInteractionsWithContactsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	> &
		(
			| { variables: GQLInteractionsWithContactsQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	>(InteractionsWithContactsDocument, options);
}
export function useInteractionsWithContactsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	>(InteractionsWithContactsDocument, options);
}
// @ts-ignore
export function useInteractionsWithContactsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	>,
): Apollo.UseSuspenseQueryResult<
	GQLInteractionsWithContactsQuery,
	GQLInteractionsWithContactsQueryVariables
>;
export function useInteractionsWithContactsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLInteractionsWithContactsQuery,
				GQLInteractionsWithContactsQueryVariables
		  >,
): Apollo.UseSuspenseQueryResult<
	GQLInteractionsWithContactsQuery | undefined,
	GQLInteractionsWithContactsQueryVariables
>;
export function useInteractionsWithContactsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLInteractionsWithContactsQuery,
				GQLInteractionsWithContactsQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GQLInteractionsWithContactsQuery,
		GQLInteractionsWithContactsQueryVariables
	>(InteractionsWithContactsDocument, options);
}
export type InteractionsWithContactsQueryHookResult = ReturnType<
	typeof useInteractionsWithContactsQuery
>;
export type InteractionsWithContactsLazyQueryHookResult = ReturnType<
	typeof useInteractionsWithContactsLazyQuery
>;
export type InteractionsWithContactsSuspenseQueryHookResult = ReturnType<
	typeof useInteractionsWithContactsSuspenseQuery
>;
export type InteractionsWithContactsQueryResult = Apollo.QueryResult<
	GQLInteractionsWithContactsQuery,
	GQLInteractionsWithContactsQueryVariables
>;
export const InteractionDocument = gql`
    query Interaction($input: InteractionQueryInput!) {
  interaction(input: $input) {
    ...InteractionFields
  }
}
    ${InteractionFieldsFragmentDoc}`;

/**
 * __useInteractionQuery__
 *
 * To run a query within a React component, call `useInteractionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInteractionQuery(
	baseOptions: Apollo.QueryHookOptions<
		GQLInteractionQuery,
		GQLInteractionQueryVariables
	> &
		(
			| { variables: GQLInteractionQueryVariables; skip?: boolean }
			| { skip: boolean }
		),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GQLInteractionQuery, GQLInteractionQueryVariables>(
		InteractionDocument,
		options,
	);
}
export function useInteractionLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GQLInteractionQuery,
		GQLInteractionQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GQLInteractionQuery, GQLInteractionQueryVariables>(
		InteractionDocument,
		options,
	);
}
// @ts-ignore
export function useInteractionSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GQLInteractionQuery,
		GQLInteractionQueryVariables
	>,
): Apollo.UseSuspenseQueryResult<
	GQLInteractionQuery,
	GQLInteractionQueryVariables
>;
export function useInteractionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLInteractionQuery,
				GQLInteractionQueryVariables
		  >,
): Apollo.UseSuspenseQueryResult<
	GQLInteractionQuery | undefined,
	GQLInteractionQueryVariables
>;
export function useInteractionSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLInteractionQuery,
				GQLInteractionQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GQLInteractionQuery,
		GQLInteractionQueryVariables
	>(InteractionDocument, options);
}
export type InteractionQueryHookResult = ReturnType<typeof useInteractionQuery>;
export type InteractionLazyQueryHookResult = ReturnType<
	typeof useInteractionLazyQuery
>;
export type InteractionSuspenseQueryHookResult = ReturnType<
	typeof useInteractionSuspenseQuery
>;
export type InteractionQueryResult = Apollo.QueryResult<
	GQLInteractionQuery,
	GQLInteractionQueryVariables
>;
